const PATH_SEPARATOR = '::';
export const getRenderIDFromPath = (renderPath) => renderPath.join(PATH_SEPARATOR);
export const getPathFromRenderID = (renderID) => renderID.split(PATH_SEPARATOR);
